var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Import',{attrs:{"title":"Exchange Rate","check_validation":'currency/importexchangeratevalidation',"url":_vm.url,"items":_vm.items,"show_message":'',"sample_file_name":'sample-exchange-rate-data.xlsx',"show_dup_handle":{
      show:false,
      value:1}},on:{"redirectPage":_vm.redirectPage,"import":_vm.submit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }